import React from 'react';

import {
  H1,
  H2,
  Subtitle2,
  Preamble,
  Table,
  TableHead,
  TableHeadCell,
  TableBody,
  TableRow,
  TableCell,
  Link,
} from '@aurora/widgets-react';

const Parameters = () => (
  <React.Fragment>
    <H1>Parameters</H1>
    <Preamble>
      The API has no concept of products and all requests are made by requesting
      individual parameters. This page describes all parameters and their
      parmeternrs.
    </Preamble>

    <Preamble>
      Even if the API knows nothing about products, a customer is a subscriber
      to a product. A product is nothing more than a bundle of parameters. Go to{' '}
      <Link to="/products">Products</Link> to see the parameters a product
      consists of.
    </Preamble>

    <H2>Hourly Values</H2>

    <Table>
      <TableHead>
        <TableHeadCell>
          <Subtitle2>parameternr</Subtitle2>
        </TableHeadCell>
        <TableHeadCell>
          <Subtitle2>Description</Subtitle2>
        </TableHeadCell>
        <TableHeadCell>
          <Subtitle2>Unit</Subtitle2>
        </TableHeadCell>
        <TableHeadCell>
          <Subtitle2>Typecase dependent</Subtitle2>
        </TableHeadCell>
        <TableHeadCell>
          <Subtitle2>Nr of decimals</Subtitle2>
        </TableHeadCell>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>5</TableCell>
          <TableCell>Temperature at 2m</TableCell>
          <TableCell>&deg;C</TableCell>
          <TableCell>no</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>316</TableCell>
          <TableCell>Cooling demand</TableCell>
          <TableCell>W/m²</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>322</TableCell>
          <TableCell>Smoothed equivalent temperature</TableCell>
          <TableCell>&deg;C</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>325</TableCell>
          <TableCell>Phase shifted smoothed equivalent temperature</TableCell>
          <TableCell>&deg;C</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
      </TableBody>
    </Table>

    <H2>Daily Values</H2>

    <Table>
      <TableHead>
        <TableHeadCell>
          <Subtitle2>parameternr</Subtitle2>
        </TableHeadCell>
        <TableHeadCell>
          <Subtitle2>Description</Subtitle2>
        </TableHeadCell>
        <TableHeadCell>
          <Subtitle2>Unit</Subtitle2>
        </TableHeadCell>
        <TableHeadCell>
          <Subtitle2>Typecase dependent</Subtitle2>
        </TableHeadCell>
        <TableHeadCell>
          <Subtitle2>Nr of decimals</Subtitle2>
        </TableHeadCell>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>1005</TableCell>
          <TableCell>Actual average temperature at 2m</TableCell>
          <TableCell>&deg;C</TableCell>
          <TableCell>no</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>4330</TableCell>
          <TableCell>Correction factor heating degree days</TableCell>
          <TableCell>-</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>2</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>4331</TableCell>
          <TableCell>Correction factor Energy Index</TableCell>
          <TableCell>-</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>2</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>5330</TableCell>
          <TableCell>Actual heating degree days</TableCell>
          <TableCell>gd</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>5331</TableCell>
          <TableCell>Actual Energy Index</TableCell>
          <TableCell>gd</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>5316</TableCell>
          <TableCell>Actual cooling demand</TableCell>
          <TableCell>Wh/m²</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>21320</TableCell>
          <TableCell>Normal average temperature at 2m</TableCell>
          <TableCell>&deg;C</TableCell>
          <TableCell>no</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>25330</TableCell>
          <TableCell>Normal heating degree days</TableCell>
          <TableCell>gd</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>25331</TableCell>
          <TableCell>Normal Energy Index</TableCell>
          <TableCell>gd</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>25316</TableCell>
          <TableCell>Normal cooling demand</TableCell>
          <TableCell>Wh/m²</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
      </TableBody>
    </Table>

    <H2>Monthly Values</H2>

    <Table>
      <TableHead>
        <TableHeadCell>
          <Subtitle2>parameternr</Subtitle2>
        </TableHeadCell>
        <TableHeadCell>
          <Subtitle2>Description</Subtitle2>
        </TableHeadCell>
        <TableHeadCell>
          <Subtitle2>Unit</Subtitle2>
        </TableHeadCell>
        <TableHeadCell>
          <Subtitle2>Typecase dependent</Subtitle2>
        </TableHeadCell>
        <TableHeadCell>
          <Subtitle2>Nr of decimals</Subtitle2>
        </TableHeadCell>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>3005</TableCell>
          <TableCell>Actual average temperature at 2m</TableCell>
          <TableCell>&deg;C</TableCell>
          <TableCell>no</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>13316</TableCell>
          <TableCell>Correction factor Cooling Index</TableCell>
          <TableCell>-</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>2</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>13330</TableCell>
          <TableCell>Correction factor heating degree days</TableCell>
          <TableCell>-</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>2</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>13331</TableCell>
          <TableCell>Correction factor Energy Index</TableCell>
          <TableCell>-</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>2</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>16316</TableCell>
          <TableCell>Recommended correction factor Cooling Index</TableCell>
          <TableCell>-</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>2</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>16330</TableCell>
          <TableCell>
            Recommended correction factor heating degree days
          </TableCell>
          <TableCell>-</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>2</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>16331</TableCell>
          <TableCell>Recommended correction factor Energy Index</TableCell>
          <TableCell>-</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>2</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>18316</TableCell>
          <TableCell>Actual cooling demand</TableCell>
          <TableCell>Wh/m²</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>0</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>18330</TableCell>
          <TableCell>Actual heating degree days</TableCell>
          <TableCell>gd</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>0</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>18331</TableCell>
          <TableCell>Actual Energy Index</TableCell>
          <TableCell>gd</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>0</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>23320</TableCell>
          <TableCell>Normal average temperature at 2m</TableCell>
          <TableCell>&deg;C</TableCell>
          <TableCell>no</TableCell>
          <TableCell>1</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>28316</TableCell>
          <TableCell>Normal cooling demand</TableCell>
          <TableCell>Wh/m²</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>0</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>28330</TableCell>
          <TableCell>Normal heating degree days</TableCell>
          <TableCell>gd</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>0</TableCell>
        </TableRow>
        <TableRow>
          <TableCell>28331</TableCell>
          <TableCell>Normal Energy Index</TableCell>
          <TableCell>gd</TableCell>
          <TableCell>yes</TableCell>
          <TableCell>0</TableCell>
        </TableRow>
      </TableBody>
    </Table>
  </React.Fragment>
);

export default Parameters;
